import React from "react";
import { connect } from 'react-redux';
import { Actions as ACTIONS } from '../../../../store/actions/companyActions';
import { XMarkIcon, CheckCircleIcon } from '@heroicons/react/20/solid';
import { useForm } from 'react-hook-form';
import Spinner from '../../../common/Spinner';

const GatewayPasswordModal = ({
    modalStatus,
    setModalStatus,
    senderId,
    updatePassword,
    saving,
}) => {

    const { handleSubmit, register, control, watch } = useForm();

    const onSubmit = (data) => updatePassword(data.password);

    if (!modalStatus) return null;

    return (
        <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ overflow: "auto", display: "block", background: "rgba(0,0,0,0.4)" }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="block block-themed block-transparent remove-margin-b" style={{ padding: 0 }}>
                        <div className="block-header bg-primary-dark" style={{ padding: 20 }}>
                            <ul className="block-options">
                                <li>
                                    <button type="button" onClick={() => setModalStatus(false)}>
                                        <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                                    </button>
                                </li>
                            </ul>
                            <h3 className="block-title">Change HMRC Gateway Password</h3>
                        </div>
                        <div className="block-content" style={{ padding: 20, paddingBottom: 0 }}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="form-material form-container">
                                    <input
                                        className="form-control form-input"
                                        type="text"
                                        disabled
                                        autoComplete='off'
                                        value={senderId}
                                        ref={register}
                                    />
                                    <label htmlFor="material-text">Government Gateway ID</label>
                                </div>
                                <div className="form-material form-container">
                                    <input  
                                        className="form-control form-input"
                                        type="password"
                                        name="password"
                                        autoComplete='off'
                                        ref={register}
                                    />
                                    <label htmlFor="material-text">Government Gateway Password</label>
                                </div>
                                <div className="clearfix" />
                                <div className="text-right">
                                    <button className="btn btn-success" type="submit">
                                        {saving ?
                                            <Spinner
                                                style={{ height: "1.5em", float: "left", marginRight: 5, float: 'left' }}
                                                className="animate-spin h-5 w-5" />
                                            : <CheckCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                                        }
                                        <div style={{ float: "left" }}>{saving ? "Saving..." : "Save"}</div>
                                    </button>
                                </div>
                            </form>
                            <div className="clearfix" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        modalStatus: state.company?.gatewayPasswordModal?.status,
        senderId: state.company.settings?.hmrcCredentials?.senderId,
        saving: state.company?.gatewayPasswordModal?.saving,
    }
}

const mapDispatchToProps = dispatch => ({
    setModalStatus: (status) => dispatch(ACTIONS.setHMRCCredentialsModalStatus(status)),
    updatePassword: (password) => dispatch(ACTIONS.updateHMRCPassword(password)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GatewayPasswordModal)